import { createFileRoute, redirect } from '@tanstack/react-router';

/** Retired tab — renewal & cancellation now live in the single Recurring jobs page. */
export const Route = createFileRoute(
  '/_dashboard/dashboard/settings/contracts/renewal-cancellation',
)({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/contracts' });
  },
  component: () => null,
});
